import { useState } from "react";

const TimeConverter = () => {

  const [input, setInput] = useState("");
  const [result, setResult] = useState(0);

  function calculateTime(input){
    var time1 = input.slice(0, input.indexOf("-"));
    var time2 = input.slice(input.indexOf("-") + 1);
    var hours1 = time1.slice(0, -2);
    var hours2 = time2.slice(0, -2);
    var mins1 = time1.slice(-2);
    var mins2 = time2.slice(-2);
    var difference = (hours2 - hours1) * 60;
    difference += mins2 - mins1;
    if (difference == 1){
      setResult("1 min")
    } else{
      setResult(`${difference} mins`);
    }
  }

  return (

    <section className="articles">

      <article className="web-toy">
        <div className="centered">
          <h3>Time Converter</h3>
          <div className="time-converter-input">
            <input
            type="text"
            required
            value={input}
            onChange={(e) => setInput(e.target.value)}
            style={{lineHeight: "1.8em"}}
          />
            <button onClick={() => calculateTime(input)}>Submit</button>
          </div>
          <h1>{ result }</h1>
        </div>
      </article>

    </section>

  );
}


export default TimeConverter;